module.exports = __webpack_public_path__ + "static/media/Logo_full_black.b6103df1.png";